<template>
  <div class="account-container">
    <DpplPageLoader :is-loading="pageLoading" />

    <div
      v-if="!pageLoading"
      class="form-wrapper"
    >
      <AccountForm
        :form="{
          values, errors, errorMessages, labels,
        }"
        :is-valid="isFormValid"
        :show-update-button="!integrated"
        @submit="update"
        @update:model-value="setFormValues($event)"
        @change="setIsValidated($event)"
      />

      <HideRbac :permissions="['manageEmailSubscriptions']">
        <AccountEmailSubscriptions />
      </HideRbac>

      <Loader :is-loading="componentLoading" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'pinia';
import DpplPageLoader from '@/components/datapeople/DpplPageLoader.vue';
import Loader from '@/components/settings/components/Loader.vue';
import HideRbac from '@/components/rbac/HideRbac.vue';
import { useAppAuthData } from '@/stores/app/authData';
import { useAppLoading } from '@/stores/app/loading';
import { useSettingsAccount } from '@/stores/settings/account';
import { useSettingsAccountForm } from '@/stores/settings/accountForm';
import { useSettingsConfig } from '@/stores/settings/config';
import AccountForm from './AccountForm.vue';
import AccountEmailSubscriptions from './AccountEmailSubscriptions.vue';

export default {
  name: 'AccountSettings',
  components: {
    AccountForm,
    AccountEmailSubscriptions,
    DpplPageLoader,
    HideRbac,
    Loader,
  },
  computed: {
    ...mapState(useAppAuthData, ['integrated']),
    ...mapState(useAppLoading, ['componentLoading', 'pageLoading']),
    ...mapState(useSettingsAccountForm, ['values', 'errors', 'errorMessages', 'labels', 'isFormValid']),
    ...mapState(useSettingsConfig, ['config']),
  },
  async mounted() {
    await this.load();
  },
  methods: {
    ...mapActions(useSettingsAccount, ['load', 'update']),
    ...mapActions(useSettingsAccountForm, ['setFormValues', 'setIsValidated']),
  },
};
</script>

<style scoped lang="less">
.account-container {
  width: 100%;
}

.form-wrapper {
  border-radius: 10px;
  border: 1px solid @stroke-default;
  background: @white;
  padding: 24px;
}
</style>
